import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { COMPANY, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F172A] text-slate-300 pt-16 pb-24 lg:pb-16"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="mb-4">
            <img
              src="/assets/logo.png"
              alt="Boston Express Plumbing and Heating LLC"
              className="h-40 w-auto invert"
            />
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            Licensed, insured plumbing & heating services in Stoughton, MA
            for over 10 years.
          </p>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4 text-sm tracking-[0.12em] uppercase">
            Services
          </h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link
                  to="/services"
                  data-testid={`footer-service-${s.slug}-link`}
                  className="hover:text-[#0284C7] transition-colors"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4 text-sm tracking-[0.12em] uppercase">
            Contact
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 mt-0.5 text-[#0284C7]" strokeWidth={1.75} />
              <a
                href={`tel:${COMPANY.phoneTel}`}
                data-testid="footer-phone-link"
                className="hover:text-white"
              >
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 mt-0.5 text-[#0284C7]" strokeWidth={1.75} />
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email-link"
                className="hover:text-white break-all"
              >
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-0.5 text-[#0284C7]" strokeWidth={1.75} />
              <span>{COMPANY.address}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4 text-sm tracking-[0.12em] uppercase">
            Hours
          </h4>
          <ul className="space-y-2 text-sm">
            {COMPANY.hours.map((h, i) => (
              <li key={i} className="flex items-start gap-2">
                <Clock className="h-4 w-4 mt-0.5 text-[#0284C7]" strokeWidth={1.75} />
                <div>
                  <div className="text-white font-semibold">{h.day}</div>
                  <div className="text-slate-400">{h.time}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-slate-500">
        <p>
          © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
        </p>
        <p>Licensed & Insured · Stoughton, MA</p>
      </div>
    </footer>
  );
}
